import { ApplicationState } from '../index';

import { ConnectionDescriptor } from '../../Models/Api/strongbox.financialportal';

import { WorkspaceWithMeta, WorkspacePageInfo, WorkspacePlusUser } from './Reducer';

/*
 * Returns true if workspaces are activebly being loaded
 */

export function LoadingWorkspaces(state: ApplicationState): boolean {
    if (!(state && state.workspaces)) {
        return false;
    }
    return state.workspaces.loading;
}

export function GetWorkspaceInfo(state: ApplicationState): { workspaces: WorkspaceWithMeta[], pageInfo: WorkspacePageInfo } | undefined {
    if (!(state && state.workspaces)) {
        return undefined;
    }
    return {
        workspaces: state.workspaces.workspaces,
        pageInfo: state.workspaces.pageInfo
    };
}

export function GetDetailedWorkspaces(state: ApplicationState): WorkspacePlusUser[] {
    if (!(state && state.workspaces && state.workspaces.details)) {
        return [];
    }

    return state.workspaces.details;
}

// A shared, stable empty array so callers that feed the result into memo/dependency comparisons don't
// see a new reference on every render when a workspace has no connections loaded.
export const EmptyWorkspaceConnections: ConnectionDescriptor[] = [];

/*
 * Returns the active connections loaded for a specific workspace (empty if none are loaded).
 * These are the same connections shown on the Manage Active Connections tab and are used to
 * reuse an existing connection when syncing from a past data collection.
 */

export function GetWorkspaceConnections(state: ApplicationState, workspaceId: string): ConnectionDescriptor[] {
    if (!(state && state.workspaces && state.workspaces.details)) {
        return EmptyWorkspaceConnections;
    }

    const detail = state.workspaces.details.find(d => d.id === workspaceId);
    return detail?.connections?.connections || EmptyWorkspaceConnections;
}

export function GetAllLoadedWorkspaces(state: ApplicationState): WorkspaceWithMeta[] | undefined {
    if (!(state && state.workspaces)) {
        return undefined;
    }
    return state.workspaces.workspaces.concat(state.workspaces.inactiveWorkspaces);
}
